import { render, staticRenderFns } from "./ToTgChanel.vue?vue&type=template&id=5c1ede57&scoped=true"
import script from "./ToTgChanel.vue?vue&type=script&lang=js"
export * from "./ToTgChanel.vue?vue&type=script&lang=js"
import style0 from "./ToTgChanel.vue?vue&type=style&index=0&id=5c1ede57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1ede57",
  null
  
)

export default component.exports